import React, { useEffect, useState } from "react";
import useMedia from "../../../services/Whatsapp/useMedia";
import useWhatsappNumbers from "../../../services/Whatsapp/useWhatsappNumbers";
import { toast, ToastContainer } from "react-toastify";

const TemplateModal = ({
  
  show,
  onClose,
  templates,
  executeTemplate,
  fetchChats,
  WhatsappNumbers,
  SingleWhatsApp,
  setSingleWhatsApp,
  selectedContact,
}) => {

  const [templateVarsById, setTemplateVarsById] = useState({});
  const [templateMedia, setTemplateMedia] = useState({});

  const { uploadImage, uploadVideo } = useMedia();
  // const { whatsappNumbers } = useWhatsappNumbers();

const numbers = WhatsappNumbers || [];

const selectedValue =
  SingleWhatsApp !== "" && SingleWhatsApp !== null
    ? SingleWhatsApp
    : numbers.length > 0
    ? numbers[0].phone_no_id
    : "";

  const handleMediaUpload = async (tplId, file, headerFormat) => {
    if (!file) return;

    try {
      if (headerFormat === "IMAGE") {
        const reader = new FileReader();

        reader.onload = async () => {
          const base64 = reader.result.split(",")[1];
          const response = await uploadImage(file.name, base64);

          if (response?.status === "0") {
            const imageUrl = response?.image_url;

            setTemplateMedia((prev) => ({
              ...prev,
              [tplId]: {
                mediaUrl: imageUrl,
                fileName: file.name,
              },
            }));

            toast.success("Image uploaded successfully");
          }
        };

        reader.readAsDataURL(file);
      } else if (headerFormat === "VIDEO" || headerFormat === "DOCUMENT") {
        const response = await uploadVideo(file);

        if (response?.responseCode === "00") {
          setTemplateMedia((prev) => ({
            ...prev,
            [tplId]: {
              mediaId: response?.data?.mediaId,
              mediaUrl: response?.data?.mediaUrl,
              fileName: file.name,
            },
          }));

          toast.success("File uploaded successfully");
        }
      }
    } catch (err) {
      console.error("Media Upload Error:", err);
    }
  };

  if (!show) return null;

  return (
    <>
    <ToastContainer />
   
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 montserrat-font-1"
      onClick={(e) => {
    if (e.target === e.currentTarget) onClose(); 
  }}
>
      <div className="bg-white w-full max-w-4xl rounded-xl shadow-xl montserrat-font-1">

        <div className="flex justify-between items-center border-b px-6 py-4 montserrat-font-1">
          <h2 className="text-lg font-semibold">WhatsApp Templates</h2>

          <div className="flex items-center gap-3 montserrat-font-1">

<select
  value={selectedValue}
  onChange={(e) => setSingleWhatsApp(e.target.value)}
   onClick={(e) => e.stopPropagation()}  
  disabled={numbers.length <= 1}
  className="border rounded-md px-3 py-1.5 text-sm min-w-[240px]"
>
  {numbers.length > 1 && (
    <option value="">Select WhatsApp Number</option>
  )}

  {numbers.map((n, i) => (
    <option key={`${n.phone_no_id}-${i}`} value={n.phone_no_id}>
      {n.phone_no_id} ({n.phone_no})
    </option>
  ))}
</select>

            <button
              onClick={onClose}
              className="text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
          </div>
        </div>


        <div className="p-6 max-h-[70vh] overflow-y-auto montserrat-font-1">
          {!Array.isArray(templates) || templates.length === 0 ? (
            <div className="text-center text-gray-500 py-8">
              No templates found
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 montserrat-font-1">
              {templates.map((tpl) => {
                const body = tpl.components?.find((c) => c.type === "BODY");
                const bodyText = body?.text || "";

                const ph = (bodyText.match(/\{\{\d+\}\}/g) || [])
                  .map((s) => Number(s.replace(/[{}]/g, "")))
                  .filter((v, i, a) => a.indexOf(v) === i);

                const header = tpl.components?.find((c) => c.type === "HEADER");
                const headerFormat = header?.format;

                const vars = templateVarsById[tpl.id] || [];
                const media = templateMedia[tpl.id] || {};

                return (
                  <div
                    key={tpl.id}
                    className="border rounded-lg p-3 shadow-sm flex flex-col montserrat-font-1"
                  >
                    {/* Title */}

                    <div className="flex justify-between items-center montserrat-font-1">
                      <h6 className="font-semibold">
                        {tpl?.name || "Template"}
                      </h6>

                      <span className="text-xs bg-gray-200 px-2 py-0.5 rounded">
                        {tpl?.category || "-"}
                      </span>
                    </div>

                    {/* Meta */}

                    <div className="text-xs text-gray-500 mb-2 montserrat-font-1">
                      Language: <b>{tpl.language}</b> | Status:{" "}
                      <b>{tpl?.status || "-"}</b>
                    </div>

                    {/* Body Preview */}

                    <div className="text-sm mb-3 max-h-[80px] overflow-auto montserrat-font-1">
                      {bodyText}
                    </div>

                    {headerFormat && (
                      <div className="mb-3">
                        <div className="text-xs font-semibold mb-1">
                          Header Media ({headerFormat})
                        </div>

                        <input
                          type="file"
                          className="text-sm"
                          accept={
                            headerFormat === "IMAGE"
                              ? "image/*"
                              : headerFormat === "VIDEO"
                                ? "video/*"
                                : ".pdf,.doc,.docx,.xls,.xlsx"
                          }
                          onChange={(e) => {
                            const file = e.target.files[0];
                            handleMediaUpload(tpl.id, file, headerFormat);
                          }}
                        />

                        {templateMedia[tpl.id]?.fileName && (
                          <div className="text-xs text-green-600 mt-1">
                            Uploaded: {templateMedia[tpl.id].fileName}
                          </div>
                        )}
                      </div>
                    )}

                    {ph.length > 0 && (
                      <div className="mb-3">
                        <div className="text-xs font-semibold mb-1">
                          Template Variables
                        </div>

                        {ph.map((n, idx) => (
                          <input
                            key={n}
                            className="w-full border rounded px-2 py-1 text-sm mb-2"
                            placeholder={`Value for {{${n}}}`}
                            value={vars[idx] || ""}
                            onChange={(e) => {
                              const next = [...vars];
                              next[idx] = e.target.value;

                              setTemplateVarsById((prev) => ({
                                ...prev,
                                [tpl.id]: next,
                              }));
                            }}
                          />
                        ))}
                      </div>
                    )}

                    <div className="mt-auto flex justify-end montserrat-font-1">
                      <button
                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-sm"
                        onClick={async () => {
                          if (!SingleWhatsApp) {
                            toast.error("Please select WhatsApp number");
                            return;
                          }

                          const vars = templateVarsById[tpl.id] || [];
                          const media = templateMedia[tpl.id] || {};

                          if (header?.format === "IMAGE" && !media.mediaUrl) {
                            toast.error("Please upload image first");
                            return;
                          }

                          const payload = {
                            // contacts: [SingleWhatsApp],
                            contacts: [selectedContact.contact_number],
                            templateId: tpl.id,
                            templateName: tpl.name,
                            type: tpl.category,
                            languageCode: tpl.language,

                            format: header?.format?.toLowerCase() || "text",

                            messaging_product: "whatsapp",
                            execute_type: "N",
                            secret: "N",

                            headerParams:
                              header?.format === "IMAGE"
                                ? [media.mediaUrl]
                                : header?.format === "VIDEO" ||
                                    header?.format === "DOCUMENT"
                                  ? [media.mediaId]
                                  : [],

                            bodyParams: vars,
                            footerParams: [],
                          };

                          const res = await executeTemplate(payload);

                          if (res?.responseCode === "00") {
                            toast.success("Template sent successfully");

                            if (fetchChats) {
                              await fetchChats(SingleWhatsApp);
                            }
                          } else {
                            toast.error("Failed to send template");
                          }
                        }}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default TemplateModal;
